import { Component, Input, NgModule, OnInit } from '@angular/core'
import { LikeService } from '@service/like.service'
import { UserService } from '@service/user/user.service'
import { Likeable } from '@interface/likeable';
import { SharedModule } from 'src/app/shared.module';

@Component({
  selector: 'like-button',
  templateUrl: './like-button.component.html',
  styleUrls: ['./like-button.component.scss'],
})
export class LikeButtonComponent implements OnInit {

  @Input()
  public set likeable(likeable: Likeable) {
    this._likeable = likeable
    this.likedByMe = this.likedByMe_f()
    this.likeCount = likeable.count_likes
  }
  public get likeable() {
    return this._likeable
  }
  private _likeable: Likeable

  public likedByMe: boolean = false
  public likeCount: number = 0

  @Input()
  public live: boolean = true

  @Input() public hideTextMobile: boolean = false

  constructor(
    private likeService: LikeService,
    public userService: UserService,
  ) { }

  ngOnInit() { }

  public toggleLike() {

    // dislike
    if (this.likedByMe) {
      this.likeCount--
      if (this.live) {
        this.likeService.delete(this.likeable)
      }
    }

    // like
    else {
      this.likeCount++
      if (this.live) {
        this.likeService.add(this.likeable)
      }
    }

    // finally toggle it anyway so the user does not feel discomforted
    this.likedByMe = !this.likedByMe
  }

  public likedByMe_f(): boolean {

    // if not logged in we dont know if you liked it
    if (!this.userService.user)
      return false

    if (this.likeable && this.likeable.likes) {
      const ownLike = this.likeable.likes.filter(l => l.frontend_user_id == this.userService.user.id)
      return ownLike && ownLike.length > 0
    } else {
      return false
    }
  }
}

@NgModule({
  declarations: [
    LikeButtonComponent
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    LikeButtonComponent,

    SharedModule,
  ]
})
export class LikeButtonComponentModule { }